import React from 'react';
import defaultLocale from '../../configs/defaultLocale';

export const LocaleContext = React.createContext<string>(defaultLocale);
